export default [
  {
    title: 'Product',
    customIcon: 'ProductSvg',
    children: [
      {
        title: 'Product List',
        route: 'product-list',
        path: '/product/list',
      },
    ],
  },
];
